<template>
  <div data-cy="schedule-visit-button">
    <ActionsMenu :actions="actions" @schedule-visit="handleScheduleVisit" />
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { EventBus } from "@/lib/event_bus.js";

import ActionsMenu from "@/components/ActionsMenu.vue";
import { Address } from "@/typings/address";
import { Customer } from "@/typings/customer";

const props = defineProps<{
  customer: Customer;
  address: Address;
  membership_program_item_id: number;
  task_name: string;
  scheduling_source: "service_utilization" | "covered_tasks";
}>();

export type ScheduleVisitEventPayload = {
  customer: Customer;
  address: Address;
  membership_program_item_id: number;
  task_name: string;
  scheduling_source: "service_utilization" | "covered_tasks";
};

const actions = computed(() => [
  {
    label: "Schedule Visit",
    icon: "fa-regular fa-calendar-plus",
    eventName: "schedule-visit",
    className: "schedule-visit-action"
  }
]);

const handleScheduleVisit = () => {
  const payload: ScheduleVisitEventPayload = {
    customer: props.customer,
    address: props.address,
    membership_program_item_id: props.membership_program_item_id,
    task_name: props.task_name,
    scheduling_source: props.scheduling_source
  };
  EventBus.$emit("open-schedule-visit-modal", payload);
};
</script>

<style scoped></style>
